module.exports = __webpack_public_path__ + "static/media/100.341b8ee6.svg";